<template>
  <div>
    <h6 @click="toggleCollapse" class="attribute-listing-filters-group-name">
      {{ group.attributeGroupName }}
      <button class="attribute-listing-filters-group-collapse-btn">
        <em :class="['ti-close', { 'ti-angle-down': !collapsed, 'ti-angle-up': collapsed }]"></em>
      </button>
    </h6>
    <transition name="collapse-fade">
      <div
        v-if="!collapsed"
        class="attribute-listing-filters-attribute-entries"
        :class="[getAttributeEntriesClassName, { overflowEntries: group.attributeGroupName === 'Αποχρωση' }]"
      >
        <EntryFilter
          v-for="attributeEntry in entries"
          :key="attributeEntry.id"
          :entry="attributeEntry"
          :group="group"
          class="attribute-listing-filters-attribute-entry"
        >
        </EntryFilter>
      </div>
    </transition>
  </div>
</template>

<script>

import EntryFilter from './EntryFilter'

export default {
  name: 'GroupFilter',
  components: {
    EntryFilter
  },
  data () {
    return {
      collapsed: false
    }
  },
  props: {
    group: {
      attributeDisplayType: '',
      attributeGroupId: '',
      attributeGroupName: null,
      attributeGroupStep: 0,
      attributeGroupDisplayPosition: 0,
      attributes: []
    },
    entries: {
      type: Array
    },
    isBaseGroup: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    getAttributeEntriesClassName () {
      let className = ''
      if (!this.isBaseGroup) {
        className += 'range_group '
      }
      className += this.group.attributeDisplayType
      if (this.collapsed) {
        className += ' collapsed'
      }
      return className
    }
  },
  methods: {
    toggleCollapse () {
      this.collapsed = !this.collapsed
    }
  }
}
</script>

<style lang="scss" scoped>
.attribute-listing-filters-group-collapse-btn {
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  text-align: center;
  background: unset;
  border: unset;
}
.ti-close {
  font-size: 14px;
}
.collapse-fade-enter-active, .collapse-fade-leave-active {
  transition: opacity 0.5s;
}
.collapse-fade-enter, .collapse-fade-leave-to {
  opacity: 0;
}

.overflowEntries {
  max-height: 400px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #999 transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #bbb;
    border-radius: 10px;
    transition: background-color 0.3s ease;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: #888;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
}
</style>
